import { OwAccordion } from "@components/shared/OwAccordion/OwAccordion";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import OwTextArea from "@components/shared/OwTextArea/OwTextArea";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import WhatsThis from "@components/shared/WhatsThis/WhatsThis";
import SupplierContext from "@contexts/SupplierContext";
import ICatalog from "@models/ICatalog";
import TitleTagEnum from "@models/TitleTagEnum";
import { isString } from "lodash-es";
import React, { useContext, useState } from "react";

type Props = {
    handleChange: (e: React.ChangeEvent<any>) => void;
    borderClass: string;
    catalogs: ICatalog[];
};

export const QuickbooksDesktopConfigInvoicesSection = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const { qbd_Templates } = supplierModel.Supplier_Integration;

    const [supplierIntegration, setSupplierIntegration] = useState({
        qbd_Invoice_TemplateRef: supplierModel.Supplier_Integration.qbd_Invoice_TemplateRef,
        qbd_allow_straight_invoice: supplierModel.Supplier_Integration.qbd_allow_straight_invoice || false,
        qbd_has_grouped_invoice: supplierModel.Supplier_Integration.qbd_has_grouped_invoice || false,
        qbd_invoice_use_order_ship_to: supplierModel.Supplier_Integration.qbd_invoice_use_order_ship_to || false,
        qbd_UseOWOrderNoForInvoice: supplierModel.Supplier_Integration.qbd_UseOWOrderNoForInvoice || false,
    });

    const templateOptions = isString(qbd_Templates) ? JSON.parse(qbd_Templates || "") : qbd_Templates || [];

    const handleChange = (e: React.ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const updatedSupplierIntegration = {
            ...supplierIntegration,
            [name]: value,
        };

        setSupplierIntegration(updatedSupplierIntegration);

        props.handleChange(e);
    };

    return (
        <div className={"QuickbooksDesktopConfigInvoicesSection mb-2"}>
            <OwAccordion title={"invoices"} fullWidthClick={true} titleTag={TitleTagEnum.H5}>
                <div className={"col-12 card " + props.borderClass} data-id={"qbd-invoices-card"}>
                    <div className="card-header">
                        <OwTitle title={"invoices"} isBold={true} tag={"h5"} />
                    </div>

                    <div className="card-body">
                        <div className={""}>
                            <OwTitle title={"template"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_invoice_template_info"} />
                            <div>
                                <OwSelectOption
                                    valueProp={"ListID"}
                                    fn={handleChange}
                                    name={"qbd_Invoice_TemplateRef"}
                                    options={templateOptions}
                                    titleProp={"Name"}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_Invoice_TemplateRef"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwTitle title={"options"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"help_allow_straight_invoice"} />
                            <div>
                                <OwToggle
                                    fn={handleChange}
                                    name={"qbd_allow_straight_invoice"}
                                    label={"allow_straight_invoice"}
                                    active={supplierIntegration.qbd_allow_straight_invoice || false}
                                    labelOnRight={true}
                                />
                            </div>
                            <div>
                                <OwToggle
                                    fn={handleChange}
                                    name={"qbd_UseOWOrderNoForInvoice"}
                                    label={"use_orderwerks_order_no_as_invoice_no"}
                                    active={supplierIntegration.qbd_UseOWOrderNoForInvoice || false}
                                    labelOnRight={true}
                                />
                            </div>
                        </div>

                        {supplierModel.has_accounting ? (
                            <div className={"mt-4"}>
                                <WhatsThis subject={"qbd_grouped_invoices"} />
                                <div>
                                    <OwToggle
                                        fn={handleChange}
                                        name={"qbd_has_grouped_invoice"}
                                        label={"grouped_invoices"}
                                        active={supplierIntegration.qbd_has_grouped_invoice || false}
                                        labelOnRight={true}
                                    />
                                </div>
                            </div>
                        ) : null}

                        <div className={"mt-4"}>
                            <OwToggle
                                fn={handleChange}
                                name={"qbd_invoice_use_order_ship_to"}
                                label={"invoice_use_order_ship_to"}
                                active={supplierIntegration.qbd_invoice_use_order_ship_to || false}
                                labelOnRight={true}
                            />
                        </div>

                        {supplierModel.Supplier_Integration.qbd_has_grouped_invoice &&
                        supplierModel.Supplier_Integration.qbd_ItemSubTotalOptions ? (
                            <div>
                                <div className={"mt-4"}>
                                    <OwLabel title={"subtotal_item"} isBold={true} />
                                    <OwSelectOption
                                        name={"qbd_grouped_subtotal_item"}
                                        fn={handleChange}
                                        options={supplierModel.Supplier_Integration.qbd_ItemSubTotalOptions}
                                        titleProp={"Name"}
                                        valueProp={"ListID"}
                                        selectedOption={supplierModel.Supplier_Integration.qbd_grouped_subtotal_item}
                                        selectedOptionProp={"ListID"}
                                    />
                                </div>
                                <div className={"mt-4"}>
                                    <OwLabel title={"bottom_description"} isBold={true} />
                                    <OwTextArea
                                        name={"qbd_grouped_bottom_desc"}
                                        fn={handleChange}
                                        value={supplierModel.Supplier_Integration.qbd_grouped_bottom_desc}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
